
import ListContainer from '~/components/Common/ListView/ListContainer'

export default {
    name: 'Notice',
    components: { ListContainer },
}
